module.exports = __webpack_public_path__ + "img/user@2x.a24e00be.png";